// error.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Notifications } from '../services/notifications';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(Notifications);

  return next(req).pipe(
    catchError((error) => {
      // Aquí pots personalitzar el missatge segons status, etc.
      notification.showError(
        error.message ||
          'Se ha producido un error inesperado, por favor, inténtalo de nuevo más tarde.'
      );

      // Si vols que continuï pujant l’error:
      return throwError(() => error);
    })
  );
};
